import { render, staticRenderFns } from "./exhibition-choice-modal.vue?vue&type=template&id=5ed2642c&scoped=true&"
import script from "./exhibition-choice-modal.vue?vue&type=script&lang=js&"
export * from "./exhibition-choice-modal.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-choice-modal.vue?vue&type=style&index=0&id=5ed2642c&lang=scss&scoped=true&"
import style1 from "./exhibition-choice-modal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed2642c",
  null
  
)

export default component.exports